<template>
  <div id="page-radio">
    <span class="logo" @click="$router.push({ name: 'Home' })" v-if="!menuVisible"></span>
    <div class="col-xs-12 col-md-10 col-md-offset-1 radio">
      <div class="box">
        <div class="row" v-if="playlist && playlist.tracks">
          <div class="col-xs-12 col-md-6">
            <div class="row">
              <div class="col-xs-12 col-md-10 col-md-offset-1">
                <div class="playlist-image">
                  <img v-if="playlist.images && playlist.images.length" :src="playlist.images[0].url" width="100%" />
                </div>

                <div v-if="current" class="row playlist-control">
                  <div class="col-xs-2 col-xs-offset-3">
                    <button type="button" class="control-previous" @click="$bus.$emit('spotify-player-previus')" v-html="nextSVG">Previous</button>
                  </div>
                  <div class="col-xs-2" v-if="paused">
                    <button type="button" class="control-play" @click="$bus.$emit('spotify-player-resume')" v-html="playSVG">Play</button>
                  </div>
                  <div class="col-xs-2" v-if="!paused">
                    <button type="button" class="control-pause" @click="$bus.$emit('spotify-player-pause')" v-html="pauseSVG">Pause</button>
                  </div>
                  <div class="col-xs-2">
                    <button type="button" class="control-next" @click="$bus.$emit('spotify-player-next')" v-html="nextSVG">Next</button>
                  </div>
                </div>

                <transition appear name="fade">
                  <div v-if="current" class="row current-track">
                    <div class="col-xs-12 col-sm-12 col-md-3">
                      <img :src="current.album.images[0].url" width="100%" />
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-9">
                      <span class="now-playing" v-text="configs.now_playing"></span>
                      <span class="name">{{ current.name }}</span>
                      <span class="artist" v-text="getArtists(current.artists)"></span>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 playlist">
            <h1 v-text="configs.title"></h1>
            <span class="songs" v-if="playlist && playlist.tracks && playlist.tracks.items">{{ playlist.tracks.total }} songs</span>
            <button type="button" class="follow" v-if="playlist && playlist.tracks && playlist.tracks.items" @click="followPlaylist()" :disabled="follow">
              <span v-if="!follow"><strong>{{configs.add_library}}</strong><strong>{{configs.add_library}}</strong></span>
              <span v-if="follow" v-text="configs.added_library">{{configs.add_library}}</span>
              <span class="spotify"></span>
            </button>
            <hr />
            <ul>
              <li v-for="(track, trackIndex) in playlist.tracks.items" :key="track.id" v-on:click="$bus.$emit('spotify-player-play', trackIndex)" v-bind:class="{ 'playing': index === trackIndex }">
                <i class="icon" v-html="(index !== trackIndex) ? playSVG : pauseSVG">
                </i>
                <div class="info">
                  <span class="name">{{ track.track.name }}</span>
                  <strong class="artist" v-text="getArtists(track.track.artists)"></strong>
                </div>
                <span class="time">{{ msToTime(track.track.duration_ms) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { msToTime } from '@/core/Utils'
import playSVG from '../../../static/images/play.svg'
import pauseSVG from '../../../static/images/pause.svg'
import nextSVG from '../../../static/images/next.svg'

export default {
  name: 'Radio',
  props: ['loginUrl'],
  dependencies: ['DATA'],
  data () {
    return {
      index: this.$spotifyTrackIndex,
      current: this.$spotifyCurrentTrack,
      playlist: this.$spotifyPlaylist,
      paused: this.$spotifyPaused,
      follow: parseInt(this.$storage.set('spotifyFollow', 0)) === 1,
      msToTime: msToTime,
      configs: this.DATA.configs.radio,
      playSVG: playSVG,
      pauseSVG: pauseSVG,
      nextSVG: nextSVG,
      menuVisible: false
    }
  },
  methods: {
    getArtists (artists) {
      return artists.map((artist) => {
        return artist.name
      }).join(', ')
    },
    followPlaylist () {
      this.$bus.$emit('spotify-playlist-follow')
      this.follow = true
    },
    showLogo (visible) {
      this.menuVisible = visible
    }
  },
  mounted () {
    if (this.$mobileDetect.mobile()) {
      this.$router.push({
        name: 'Home'
      })
      return
    }

    if (this.$storage.get('spotifyAccessToken') === null) {
      window.location.href = this.loginUrl()
      return
    } else {
      this.$bus.$emit('spotify-loadplaylist')
    }

    this.$bus.$on('spotify-player-current', (current) => {
      this.current = current
    })

    this.$bus.$on('spotify-player-index', (index) => {
      this.index = index
    })

    this.$bus.$on('spotify-player-paused', (paused) => {
      this.paused = paused
    })

    this.$bus.$on('spotify-player-playlist', (playlist) => {
      this.playlist = playlist
    })

    this.$bus.$emit('setColors', '#000', '#fff', '#fff')

    this.$bus.$on('menuVisible', (visible) => {
      this.showLogo(visible)
    })
  },
}
</script>

<style lang="scss">
@import '../../scss/variables';
@import '../../scss/easing';

#page-radio {
  .radio {
    max-width: 1700px;
    margin: 120px auto 0;
    padding-bottom: 80px;
  }
  .logo {
    background-image: url('/static/images/logo2.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 50px;
    height: 50px;
    position: absolute;
    top: 25px;
    left: 45px;
    cursor: pointer;
    z-index: 4;
    @media screen and (max-width: 64em) {
      left: 50%;
      margin-left: -25px;
    }
  }

  min-height: 82vh;
  .playlist-image {
    padding: 30px 100px;
    display: block;
    background-color: #ededed;
    overflow: hidden;
    img {
      display: block;
      margin: 0 auto;
      box-shadow: 0 0 50px rgba($color: #666666, $alpha: 0.7);
    }
  }

  .playlist-control {

    position: relative;

    @media screen and (max-width: 1200px) {
      transform: translateX(-20px);
    }

    button {
      width: 100%;
      height: 100px;
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
      fill: $purple;
      transition: transform 1s $easeInOutExpo;
      &:hover {
        transform: scale(1.3);
      }
      &:active {
        transform: scale(0.8);
      }

      &.control-previous {
        svg {
          transform: scale(0.26) rotate(180deg);
          transform-origin: 40px 50px;
        }
      }

      &.control-pause {
        g {
          transform: scale(0.36);
          transform-origin: 22px 40px;
        }
      }

      &.control-play {
        svg {
          transform: scale(1.8);
          transform-origin: -20px -30px;
        }
      }

      &.control-next {
        svg {
          transform: scale(0.26);
          transform-origin: 22px 45px;
        }
      }
    }
  }

  .current-track {
    border-top: 1px solid #e4e4e4;
    margin-top: -50px;
    padding-top: 30px;

    span {
      margin-left: -20px;
      @media screen and (max-width: 64em) {
        margin-left: 0;
      }
    }

    @media screen and (max-width: 1200px) {
      padding: 50px 0;
      margin-bottom: 50px;
    }
    .now-playing {
      display: block;
      font-size: 14px;
      font-family: $font-bold;
      text-transform: uppercase;
      padding-top: 3px;
    }
    .name {
      font-family: $font-light;
      display: block;
      letter-spacing: 1px;
      font-size: 23px;
      padding-top: 20px;
    }

    .artist {
      display: block;
      font-size: 16px;
      padding-top: 10px;
      text-transform: uppercase;
      font-family: $font-bold;
    }
  }

  ul {
    @media screen and (min-width: 75em) {
      max-height: 60vh;
      overflow: auto;
    }

    li {
      cursor: pointer;
      .artist {
        font-family: $font-light;
        display: block;
      }
      transition: 0.3s $easeOutBack;
      &:hover,
      &.playing {
        color: $purple;
        .icon {
          fill: $purple;
        }
      }
    }
  }

  .playlist {
    h1 {
      font-family: $font-bold;
      font-size: 48px;
      letter-spacing: -1px;
      padding-bottom: 30px;
    }

    .songs {
      background-color: $yellow;
      padding: 15px 10px 10px;
      display: inline-block;
      font-family: $font-bold;
      text-transform: uppercase;
    }

    .follow {
      border: none;
      color: $white;
      padding: 16px 75px;
      margin-left: 25px;
      font-size: 18px;
      font-family: $font-bold;
      outline: none;
      display: inline-block;
      cursor: pointer;
      position: relative;
      text-indent: -2.2em;
      text-align: left;
      text-decoration: none;
      background: linear-gradient(to bottom, #00ce34 0%, #00ce34 50%, #59ef7f 51%, #59ef7f 100%);
      background-size: 100% 210%;
      transition: background 0.3s $easeOutQuint;

      strong:last-child {
        position: absolute;
        top: 0px;
        left: 0px;
        padding: 16px 75px;
        width: 100%;
        display: block;
        opacity: 0;
        transition: transform 0.3s $easeOutBack, opacity 0.2s linear;
        transform: translate3d(0px, 10px, 0px);
        color: #000;
        opacity: 0;
        pointer-events: none;
      }
      
      strong:first-child {
        transition: transform 0.3s $easeOutBack, opacity 0.2s linear;
        transform: translate3d(0px, 0px, 0px);
        display: block;
        top: 0px;
        position: relative;
      }

      &[disabled] {
        opacity: 0.5;
        color: #2ed05f !important;
        cursor: default;
        background: transparent;
        border: 1px solid #2ed05f;
        text-indent: 0;
        .spotify {
          filter: invert(1) !important;
        }
      }

      &:hover {
        background-position: 0% 99%;
        strong:last-child {
          transform: translate3d(0px, 0px, 0px);
          opacity: 1;
        }
        strong:first-child {
          transform: translate3d(0px, -10px, 0px);
          opacity: 0;
        }
        .spotify {
          filter: invert(0);
        }
      }
      .spotify {
        background-image: url('/static/images/spotify.svg');
        background-repeat: no-repeat;
        width: 1.8em;
        height: 1.8em;
        display: inline-table;
        background-size: cover;
        position: absolute;
        top: 50%;
        right: 20px;
        margin-top: -1em;
        filter: invert(100%);
        transition: filter 0.3s linear;
      }
    }

    hr {
      margin-top: 29px;
      margin-bottom: 30px;
      border-color: #e4e4e4;
      border-top: 0;
      border-left: 0;
      border-right: 0;
    }

    ul {
      li {
        float: left;
        width: 100%;
        .icon {
          float: left;
          width: 4%;
          height: 3em;
          background-size: 40%;
          transition: all 1s $easeInOutExpo;
          svg {
            transform: scale(0.6);
            transform-origin: 0 35px;
            max-width:100%;
          }
        }
        &.playing {
          .icon {
            fill: $purple;
            svg {
              transform: scale(1);
              g {
                transform: scale(.13);
                transform-origin: 0 15px;
              }
            }
          }
        }
        .info {
          float: left;
          width: 85%;
          .name {
            font-family: $font-light;
            font-size: 21px;
          }
          .artist {
            font-family: $font-bold;
            margin-top: 9px;
            font-size: 17px;
            text-transform: uppercase;
          }
        }
        .time {
          float: left;
          width: 11%;
          height: 3em;
          font-family: $font-light;
          font-size: 24px;
        }
      }
    }

    @media screen and (max-width: 1200px) {
      .songs {
        margin: 0 auto 20px;
        display: block;
        text-align: center;
        width: 10em;
      }
      .follow {
        margin: 0 auto 20px;
        width: 100%;
        text-align: center;
      }
      ul {
        li {
          .icon {
            width: 0;
          }
          .info {
            width: 89%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/radio/index.vue